import React, { useEffect, useRef, useState } from 'react';
import { connect, history } from 'umi';
import { buriedBtnPoint, buriedPoint } from '@home/utils/buriedPoint';
import { Bubble, Button, Card, Justify, Layout, SearchBox } from 'tea-component';
// import { useScroll } from 'ahooks';
import { DATALAB_EDITOR, SYSTEM_NAME } from '@dbl/core/global';
import { updateUrlParams, useDblIntl } from '@/pages/datalab/utils/utils';
import DataTable from './components/DataTable';
import './index.scss';

const { Content } = Layout;

const SqlView = (props: any) => {
  const { allPrivileges, gameCode } = props || {};
  const query = history.location.query;
  const { dblFormatMessage: dataFormatMessage } = useDblIntl("sql_view");
  const stickyRef = useRef(null);
  // const inViewport = useScroll(stickyRef) as { "left": number; "top": number; };
  // const ceilingThreshold = inViewport?.top > 400;

  // 搜索框点击搜索按钮后, 触发表格请求的搜索字段
  const [searchWords, setSearchWords] = useState<string | undefined>(query?.keywords ?? '');
  const [selectTables, setSelectTables] = useState<string[]>([]);
  // 搜索框受控value
  const [searchValue, setSearchValue] = useState<string | undefined>(query?.keywords ?? '');
  // 新增sql视图弹窗
  const [visible, setVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    buriedPoint({
      pageId: '601901',
      pageName: 'SQL视图',
      pagePath: '/DataManagement/SqlView',
      extInfo: `{"pageName": "SQL View", "pageNameCn": "SQL视图", "id": ""}`,
      uid: gameCode,
      typeId: 'datalab_pc_v2',
      menuId: '0',
    });
  }, [gameCode]);

  return (
    <Content >
      <Content.Header
        // style={{
        //   display: ceilingThreshold ? 'none' : 'inline'
        // }}
        title={dataFormatMessage('title')}
      />
      <Content.Body full className="dbl-sql-view" ref={stickyRef}
      // style={{
      //   padding: ceilingThreshold ? '0px 24px' : '20px 24px'
      // }}
      >
        <Justify
          className="dbl-sql-view-buttom"
          left={
            <>
              <Button
                type="primary"
                onClick={() => {
                  buriedBtnPoint({
                    buttonId: "601901001",
                    extInfo: `{"pageName": "SQL View", "pageNameCn": "SQL视图", "id": ""}`,
                    pageId: '601901',
                    typeId: 'datalab_pc_v2',
                  });
                  setIsEdit(false);
                  setVisible(true);
                }}
              >
                {dataFormatMessage('add_new_sql_view')}
              </Button>
              <Bubble dark content={selectTables?.length < 1 ? dataFormatMessage('enter_analysis_tooltip') : ""} placement={'right'}>
                <Button
                  disabled={!allPrivileges?.includes(DATALAB_EDITOR.AddChartBtn) || selectTables?.length < 1}
                  type="primary"
                  onClick={() => {
                    window.open(`/${SYSTEM_NAME}/${gameCode}/Analysis/MultiAnalysis?tableId=${selectTables?.map(item => item?.table_id).join(',')}`);
                  }}
                >
                  {dataFormatMessage('enter_analysis')}
                </Button>
              </Bubble>
            </>
          }
          right={
            <SearchBox
              className="dbl-sql-view-search"
              value={searchValue}
              onChange={(value) => {
                setSearchValue(value);
                if (!value) {
                  setSearchWords('');
                }
              }}
              onSearch={(keyword) => {
                setSearchWords(keyword);
                if (keyword?.length !== 0) {
                  updateUrlParams({
                    searchValue: keyword,
                    filterValue: { "category": "all" },
                    sort: { "by": "create_time_str", "order": "desc" },
                    quickValue: { "creators": [], "labels": [], "cycles": [], "chart_names": [] }
                  });
                } else {
                  updateUrlParams({
                    searchValue: keyword
                  });
                }
              }}
              onClear={() => {
                setSearchWords('');
                updateUrlParams({ searchValue: '' });
              }}
              placeholder={dataFormatMessage('search')}
            />
          }
        />
        <Card>
          <Card.Body>
            <DataTable
              // className='dbi-table-sticky'
              gameCode={gameCode}
              searchWords={searchWords}
              selectTables={selectTables}
              setSelectTables={setSelectTables}
              visible={visible}
              setVisible={setVisible}
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              clearSearchWords={() => {
                setSearchWords('');
                setSearchValue('');
              }} />
          </Card.Body>
        </Card>
      </Content.Body>
    </Content>
  );
};


export default connect((state: any) => ({
  allPrivileges: state.privilegesConfig.allPrivileges,
  gameCode: state.datalab.gameCode,
}))(SqlView);